/** Application configuration constants. */

const viteEnv = import.meta.env as Record<string, string | undefined>;

function publicEnv(key: string, fallback: string): string {
  const viteValue = viteEnv[`VITE_${key}`];
  if (viteValue !== undefined && viteValue !== "") return viteValue;
  const nextValue = viteEnv[`NEXT_PUBLIC_${key}`];
  if (nextValue !== undefined && nextValue !== "") return nextValue;
  return fallback;
}

export const KEYCLOAK_URL = publicEnv("KEYCLOAK_URL", "");
export const KEYCLOAK_REALM = publicEnv("KEYCLOAK_REALM", "intake-realm");
export const KEYCLOAK_CLIENT_ID = publicEnv("KEYCLOAK_CLIENT_ID", "intake-client");
export const NOTIFICATIONS_ENABLED = publicEnv("NOTIFICATIONS_ENABLED", "false").toLowerCase() === "true";
export const PUSH_ENABLED = publicEnv("PUSH_ENABLED", "false").toLowerCase() === "true";
/** Local-only fallback identity shown in UI when Keycloak is unavailable. */
export const LOCAL_DEV_USERNAME = publicEnv("LOCAL_DEV_USERNAME", "");

/** When true, failed refresh / second 401 redirects to /login. Default on for all environments. */
export const AUTH_REDIRECT_ON_401_FAILURE = publicEnv("AUTH_REDIRECT_ON_401_FAILURE", "true").toLowerCase() === "true";

export const KEYCLOAK_CONFIG = {
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
};

/** Firebase (web) – FCM, Auth, etc. Override via NEXT_PUBLIC_FIREBASE_* in .env.local. */
export const FIREBASE_CONFIG = {
  apiKey: publicEnv("FIREBASE_API_KEY", "AIzaSyB-xbygemIeT4FCRag_Z-32XAuVbEN78Zg"),
  authDomain: publicEnv("FIREBASE_AUTH_DOMAIN", "agriwork-connect.firebaseapp.com"),
  projectId: publicEnv("FIREBASE_PROJECT_ID", "agriwork-connect"),
  storageBucket: publicEnv("FIREBASE_STORAGE_BUCKET", "agriwork-connect.firebasestorage.app"),
  messagingSenderId: publicEnv("FIREBASE_MESSAGING_SENDER_ID", "87974698034"),
  appId: publicEnv("FIREBASE_APP_ID", "1:87974698034:web:b369ae33212c09002ab02b"),
};

/**
 * Web Push / FCM getToken (Firebase Console → Cloud Messaging → Web Push certificates).
 * Public key; override via NEXT_PUBLIC_FIREBASE_VAPID_KEY in Jenkins/build-arg for other envs.
 */
export const FIREBASE_VAPID_KEY =
  publicEnv("FIREBASE_VAPID_KEY", "BAHZZn1IkuID51FKn7atMk9ltLRBioRml6giN1CA0nLb3j9S8aRRL3EV_kf5ELgG2YifhCKFNcqDmN5hyy8yg4A");
